module.exports = global.config = {    
    API_URL: "https://wholesale.yasini.com/api"
    //API_URL: "http://localhost:5000"
};